import { useWizard } from "react-use-wizard";
import tradeInSteps from "./tradeInSteps";
import RangeByRegionByFacilityTypeStep from "../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";

interface ITradeInStep_7 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const TradeInStep_7 = ({ typeIds, selectedPolygonIds }: ITradeInStep_7) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(tradeInSteps.step_6.step);
  };

  const handleNextStep = () => {
    goToStep(tradeInSteps.step_10.step);
  };

  const handleRepeatStep = () => {
    goToStep(tradeInSteps.step_8.step);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        counterPage={{
          current: tradeInSteps.step_7.page,
          max: tradeInSteps.step_7.maxPage,
        }}
        selectedPolygonIds={selectedPolygonIds ?? []}
        typeIds={typeIds ?? []}
        onNextStep={handleNextStep}
        onRepeatStep={typeIds?.length === 1 ? handleRepeatStep : undefined}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default TradeInStep_7;
